import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { HikariState } from '@/store/Hikari/state';
import getters from './getters';
import mutations from './mutations';

const state: HikariState = {
  building: '',
  entryType: '',
  currentUsageType: '',
  applyType: '',
  router: '',
  campaignRouter: '',
  phonePlan: '',
  phoneOptions: [],
  staticIp: '',
};

export const hikari: Module<HikariState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
};
